import Body from "../components/layout/Body";
import FileDetails from "../components/FileDetails";
import PatientListingSidebar from "../components/layout/Sidebar/PatientListingSidebar";

const FilePage = () => {
    return <>
        <Body mainElement={<FileDetails />} sideBar={<PatientListingSidebar />} />
    </>;
}

export default FilePage; 